
const colorMap = {
    "RED": "rgb(208, 49, 45)",
    "CHERRY RED": "rgb(153, 15, 2)",
    "ROSE": "rgb(227, 36, 43)",
    "JAM": "rgb(96, 16, 11)",
    "MERLOT": "rgb(84, 30, 27)",
    "GARNET": "rgb(97, 12, 4)",
    "CRIMSON": "rgb(185, 14, 10)",
    "Ruby": "rgb(144, 6, 3)",
    "SCARLET": "rgb(144, 13, 9)",
    "WINE": "rgb(78, 7, 7)",
    "BRICK": "rgb(126, 40, 17)",
    "APPLE": "rgb(169, 27, 13)",
    "MAHOGANY": "rgb(66, 12, 9)",
    "BLOOD": "rgb(113, 12, 4)",
    "SANGRIA RED": "rgb(94, 25, 22)",
    "BERRY": "rgb(122, 23, 18)",
    "CURRANT": "rgb(104, 12, 7)",
    "BLUSH RED": "rgb(188, 84, 75)",
    "CANDY": "rgb(210, 20, 4)",
    "LIPSTICK": "rgb(155, 16, 3)",
    "CARMINE": "rgb(150, 0, 24)",
    "PERSIAN RED": "rgb(202, 52, 51)",
    "VERMILION": "rgb(126, 25, 27)",
    "Imperial Red": "rgb(237, 41, 57)",
    "Chili Red": "rgb(194, 24, 7)",
    "Maroon": "rgb(128, 0, 0)",
    "Fire Brick": "rgb(178, 34, 34)",
    "Desire": "rgb(234, 60, 83)",
    "Raspberry": "rgb(210, 31, 60)",
    "Candy Apple": "rgb(255, 8, 0)",
    "Hibiscus": "rgb(180, 55, 87)",
    "U.S. Flag": "rgb(191, 10, 48)",
    "Ferrari": "rgb(255, 40, 0)",
    "Dark Red": "rgb(139, 0, 0)",
    "Prismatic Red": "rgb(208, 61, 51)",
    "49ers Red": "rgb(170, 0, 0)",
    "Cardinals Red": "rgb(189, 32, 49)",
    "Ajax Red": "rgb(210, 18, 46)",
    "Alabama Crimson": "rgb(158, 27, 50)",
    "Alizarin Crimson": "rgb(227, 38, 54)",
    "Amaranth Red": "rgb(244, 54, 76)",
    "American Rose": "rgb(255, 3, 62)",
    "Angels Red": "rgb(186, 0, 33)",
    "Arsenal Red": "rgb(219, 0, 7)",
    "Auburn Red": "rgb(165, 42, 42)",
    "BU Scarlet": "rgb(204, 0, 0)",
    "Bills Red": "rgb(198, 12, 48)",
    "Bittersweet Shimmer": "rgb(191, 79, 81)",
    "ORANGE": "rgb(237, 112, 20)",
    "TANGERINE": "rgb(250, 129, 40)",
    "MERIGOLD": "rgb(252, 174, 30)",
    "CIDER": "rgb(181, 103, 39)",
    "RUST": "rgb(141, 64, 4)",
    "GINGER": "rgb(190, 85, 4)",
    "TIGER": "rgb(252, 106, 3)",
    "FIRE": "rgb(221, 87, 28)",
    "BRONZE": "rgb(178, 86, 13)",
    "CANTALOUPE": "rgb(253, 161, 114)",
    "APRICOT": "rgb(237, 130, 14)",
    "CLAY": "rgb(128, 64, 11)",
    "HONEY": "rgb(236, 151, 6)",
    "CARROT": "rgb(237, 113, 23)",
    "SQUASH": "rgb(201, 91, 12)",
    "SPICE": "rgb(122, 56, 3)",
    "MARMALADE": "rgb(209, 96, 2)",
    "AMBER": "rgb(137, 49, 1)",
    "SANDSTONE": "rgb(214, 114, 41)",
    "YAM": "rgb(204, 88, 1)",
    "TANGELO": "rgb(252, 76, 2)",
    "FLAME": "rgb(227, 74, 39)",
    "FULVOUS": "rgb(230, 128, 0)",
    "Dark Orange": "rgb(255, 140, 0)",
    "Vivid Orange": "rgb(255, 94, 14)",
    "Orange-Red": "rgb(255, 69, 0)",
    "Metallic Orange": "rgb(226, 99, 16)",
    "Pumpkin": "rgb(245, 118, 26)",
    "Smashed Pumpkin": "rgb(253, 103, 58)",
    "International Orange": "rgb(255, 79, 0)",
    "Spanish Orange": "rgb(240, 97, 5)",
    "Princeton Orange": "rgb(255, 143, 0)",
    "Deep Saffron": "rgb(255, 165, 44)",
    "Alloy Orange": "rgb(195, 82, 20)",
    "Halloween Orange": "rgb(238, 89, 33)",
    "Gamboge": "rgb(232, 150, 17)",
    "Medium Vermilion": "rgb(207, 91, 46)",
    "Pastel Orange": "rgb(254, 186, 79)",
    "Philippine Orange": "rgb(242, 110, 1)",
    "Royal Orange": "rgb(255, 153, 68)",
    "Royal" : "#4169E1",
    "Coral": "rgb(255, 127, 80)",
    "Dark Coral": "rgb(215, 83, 65)",
    "Cadmium Orange": "rgb(230, 129, 47)",
    "Rajah": "rgb(250, 186, 95)",
    "Mango Tango": "rgb(251, 136, 66)",
    "Orange Peel": "rgb(255, 159, 0)",
    "Vivid Tangelo": "rgb(236, 118, 37)",
    "Persimmon": "rgb(236, 88, 0)",
    "Browns Orange": "rgb(255, 60, 0)",
    "Burnt Orange": "rgb(204, 85, 0)",
    "GREEN": "rgb(60, 176, 67)",
    "CHARTREUSE": "rgb(176, 252, 56)",
    "JUNIPER": "rgb(58, 83, 17)",
    "SAGE": "rgb(114, 140, 105)",
    "LIME": "rgb(174, 243, 89)",
    "FERN": "rgb(93, 187, 99)",
    "OLIVE": "rgb(152, 191, 100)",
    "Emerald": "rgb(2, 138, 15)",
    "PEAR": "rgb(116, 183, 46)",
    "MOSS": "rgb(70, 109, 29)",
    "SHAMROCK": "rgb(3, 172, 19)",
    "SEAFOAM": "rgb(61, 237, 151)",
    "PINE": "rgb(35, 79, 30)",
    "PARAKEET": "rgb(3, 192, 74)",
    "Mint": "rgb(153, 237, 195)",
    "SEAWEED": "rgb(53, 74, 33)",
    "PICKLE": "rgb(89, 125, 53)",
    "PISTACHIO": "rgb(178, 211, 194)",
    "BASIL": "rgb(50, 97, 45)",
    "CROCODILE": "rgb(96, 125, 59)",
    "AMAZON": "rgb(59, 122, 87)",
    "AVOCADO": "rgb(86, 130, 3)",
    "CELADON": "rgb(172, 225, 175)",
    "Forest Green": "rgb(11, 102, 35)",
    "Hunter green": "rgb(63, 112, 77)",
    "Artichoke green": "rgb(143, 151, 121)",
    "Jungle green": "rgb(41, 171, 135)",
    "Tropical Rainforest": "rgb(0, 117, 94)",
    "Persian green": "rgb(0, 166, 147)",
    "Sea green": "rgb(46, 139, 87)",
    "Jade green": "rgb(0, 168, 107)",
    "Laurel green": "rgb(169, 186, 157)",
    "Army green": "rgb(75, 83, 32)",
    "Kelly green": "rgb(76, 187, 23)",
    "Paris green": "rgb(80, 200, 120)",
    "Pakistan green": "rgb(0, 102, 0)",
    "Spring": "rgb(0, 240, 168)",
    "Chateau": "rgb(72, 168, 96)",
    "Swamp": "rgb(168, 192, 144)",
    "Mantis": "rgb(116, 195, 101)",
    "Fun": "rgb(0, 120, 72)",
    "Viridian": "rgb(96, 144, 120)",
    "Reseda Green": "rgb(108, 124, 89)",
    "Verdun": "rgb(72, 120, 0)",
    "Castleton Green": "rgb(0, 86, 59)",
    "Bottle Green": "rgb(0, 106, 78)",
    "Cadmium Green": "rgb(0, 107, 60)",
    "Camouflage Green": "rgb(120, 134, 107)",
    "Dollar Bill": "rgb(133, 187, 101)",
    "Inchworm": "rgb(178, 236, 93)",
    "BLUE": "rgb(57, 68, 188)",
    "SLATE": "rgb(117, 124, 136)",
    "SKY": "rgb(99, 197, 218)",
    "NAVY": "rgb(10, 17, 114)",
    "INDIGO": "rgb(40, 30, 93)",
    "Cobalt": "rgb(19, 56, 190)",
    "TEAL": "rgb(72, 170, 173)",
    "Ocean": "rgb(1, 96, 100)",
    "PEACOCK": "rgb(2, 45, 54)",
    "AZURE": "rgb(21, 32, 166)",
    "CERULEAN": "rgb(4, 146, 194)",
    "LAPIS": "rgb(40, 50, 194)",
    "SPRUCE": "rgb(44, 62, 76)",
    "STONE": "rgb(89, 120, 142)",
    "AEGEAN": "rgb(31, 69, 110)",
    "BLUEBERRY": "rgb(36, 21, 113)",
    "DENIM": "rgb(21, 30, 61)",
    "ADMIRAL": "rgb(5, 16, 148)",
    "SAPPHIRE": "rgb(82, 178, 191)",
    "ARCTIC": "rgb(130, 238, 253)",
    "TURQUOISE": "rgb(64, 224, 208)",
    "STEEL": "rgb(70, 130, 180)",
    "B’DAZZLED": "rgb(46, 88, 148)",
    "Powder blue": "rgb(176, 224, 230)",
    "US Air Force Academy blue": "rgb(0, 79, 152)",
    "Baby blue": "rgb(137, 207, 240)",
    "Beau blue": "rgb(188, 212, 230)",
    "Little Boy blue": "rgb(108, 160, 220)",
    "Tiffany blue": "rgb(129, 216, 208)",
    "Carolina": "rgb(75, 156, 211)",
    "Turkish blue": "rgb(79, 151, 163)",
    "Maya blue": "rgb(115, 194, 251)",
    "Cornflower blue": "rgb(100, 149, 237)",
    "Blue Sapphire": "rgb(18, 97, 128)",
    "Egyptian blue": "rgb(16, 52, 166)",
    "Yale blue": "rgb(0, 53, 107)",
    "Space Cadet": "rgb(29, 41, 81)",
    "Imperial blue": "rgb(0, 90, 146)",
    "Ruddy blue": "rgb(118, 171, 223)",
    "Air Superiority Blue": "rgb(114, 160, 193)",
    "Aquamarine Blue": "rgb(107, 202, 226)",
    "Argentina Blue": "rgb(108, 180, 238)",
    "Astros Navy": "rgb(0, 45, 98)",
    "Bayern Blue": "rgb(0, 102, 178)",
    "Berry Blue": "rgb(79, 134, 247)",
    "Blue Yonder": "rgb(80, 114, 167)",
    "Bleu de France": "rgb(49, 140, 231)",
    "Blue-Gray": "rgb(102, 153, 204)",
    "Boeing Blue": "rgb(0, 57, 166)",
    "Blue Hero": "#3171c6",
    "Braves Navy": "rgb(19, 39, 79)",
    "PURPLE": "rgb(163, 44, 196)",
    "MAUVE": "rgb(122, 73, 136)",
    "DARK VIOLET": "rgb(113, 1, 147)",
    "BOYSENBERRY": "rgb(99, 4, 54)",
    "ELECTRIC LAVENDER": "rgb(227, 159, 246)",
    "PLUM": "rgb(96, 26, 53)",
    "STRONG MAGENTA": "rgb(161, 4, 90)",
    "LILAC": "rgb(182, 95, 207)",
    "GRAPE": "rgb(102, 48, 70)",
    "ROYAL PERIWINKLE": "rgb(190, 147, 212)",
    "SANGRIA PURPLE": "rgb(77, 15, 40)",
    "EGGPLANT": "rgb(49, 20, 50)",
    "JAZZBERRY JAM": "rgb(103, 3, 47)",
    "IRIS": "rgb(152, 103, 198)",
    "Heather": "#99a196",
    "AMETHYST": "rgb(164, 94, 229)",
    "RAISIN": "rgb(41, 9, 22)",
    "MEDIUM ORCHID": "rgb(175, 105, 239)",
    "DARK MULBERRY": "rgb(76, 1, 33)",
    "DEEP WINE": "rgb(44, 4, 28)",
    "THISTLE": "rgb(216, 191, 216)",
    "ORCHID": "rgb(218, 112, 214)",
    "ELECTRIC VIOLET": "rgb(143, 0, 255)",
    "Medium Purple": "rgb(147, 112, 219)",
    "Dark Orchid": "rgb(153, 50, 204)",
    "Dark Magenta": "rgb(139, 0, 139)",
    "Veronica": "rgb(160, 32, 240)",
    "Heliotrope": "rgb(223, 115, 255)",
    "Purpureus": "rgb(154, 78, 174)",
    "Northwestern Purple": "rgb(78, 42, 132)",
    "KSU Purple": "rgb(81, 40, 136)",
    "Pomp and Power": "rgb(134, 96, 142)",
    "Mardi Gras": "rgb(136, 0, 133)",
    "Eminence": "rgb(108, 48, 130)",
    "Pansy Purple": "rgb(120, 24, 74)",
    "Palatinate": "rgb(114, 36, 108)",
    "Dark Purple": "rgb(48, 25, 52)",
    "Byzantium": "rgb(112, 41, 99)",
    "English Violet": "rgb(86, 60, 92)",
    "Affair": "rgb(111, 70, 133)",
    "Long Distance": "rgb(111, 69, 110)",
    "Prince Charming": "rgb(73, 63, 94)",
    "Lipstick Stain": "rgb(142, 71, 133)",
    "Pompadour": "rgb(114, 0, 88)",
    "Grape Color": "rgb(111, 45, 168)",
    "Pizza Edge": "rgb(154, 44, 160)",
    "Tyrian Purple": "rgb(102, 2, 60)",
    "Ultra Violet": "rgb(100, 83, 148)",
    "Electric Purple": "rgb(191, 0, 255)",
    "Studio": "rgb(120, 81, 169)",
    "BROWN OIL": "rgb(35, 23, 9)",
    "ROASTED COFFEE": "rgb(75, 55, 28)",
    "MOCHA": "rgb(60, 40, 13)",
    "PEANUT BROWN": "rgb(121, 92, 52)",
    "CAROB": "rgb(54, 37, 17)",
    "HICKORY": "rgb(55, 29, 16)",
    "WOOD": "rgb(63, 48, 29)",
    "PECAN": "rgb(74, 37, 17)",
    "WALNUT": "rgb(67, 38, 22)",
    "CARAMEL": "rgb(101, 53, 15)",
    "GINGERBREAD": "rgb(94, 44, 4)",
    "SYRUP": "rgb(72, 31, 1)",
    "DARK CHOCOLATE": "rgb(46, 21, 3)",
    "TORTILLA": "rgb(154, 123, 79)",
    "UMBER": "rgb(53, 35, 21)",
    "TAWNY": "rgb(128, 71, 28)",
    "BRUNETTE": "rgb(59, 30, 8)",
    "CINNAMON BROWN": "rgb(101, 42, 14)",
    "PENNY": "rgb(83, 41, 21)",
    "CEDAR BROWN": "rgb(74, 55, 40)",
    "BEAVER": "rgb(159, 129, 112)",
    "BISTRE": "rgb(61, 43, 31)",
    "BOLE": "rgb(121, 68, 59)",
    "Burnt umber": "rgb(138, 51, 36)",
    "Cafe au lait": "rgb(166, 123, 91)",
    "Cafe noir": "rgb(75, 54, 33)",
    "Coffee": "rgb(111, 78, 55)",
    "Deep coffee": "rgb(112, 66, 65)",
    "Copper": "rgb(184, 115, 51)",
    "Dark brown": "rgb(101, 67, 33)",
    "Taupe": "rgb(72, 60, 50)",
    "Ecru": "rgb(194, 178, 128)",
    "Golden brown": "rgb(153, 101, 21)",
    "Khaki": "rgb(195, 176, 145)",
    "Ochre": "rgb(204, 119, 34)",
    "Light brown": "rgb(181, 101, 29)",
    "Saddle brown": "rgb(139, 69, 19)",
    "Russet": "rgb(128, 70, 27)",
    "Sienna": "rgb(160, 82, 45)",
    "Antique brass": "rgb(205, 149, 117)",
    "Burlywood": "rgb(222, 184, 135)",
    "Peru": "rgb(205, 133, 63)",
    "Tumbleweed": "rgb(222, 170, 136)",
    "Dark vanilla": "rgb(209, 190, 168)",
    "Wood brown": "rgb(193, 154, 107)",
    "Chamoisee": "rgb(160, 120, 90)",
    "Deer": "rgb(186, 135, 89)",
    "Dirt": "rgb(155, 118, 83)",
    "Coconut": "rgb(150, 90, 62)",
    "Windsor tan": "rgb(167, 85, 2)",
    "BLACK": "",
    "EBONY": "rgb(8, 4, 2)",
    "CROW": "rgb(13, 9, 7)",
    "Charcoal": "#4c4c4d",
    "Midnight": "rgb(4, 4, 6)",
    "INK": "rgb(7, 5, 4)",
    "RAVEN": "rgb(5, 3, 1)",
    "OIL": "rgb(5, 1, 0)",
    "GREASE": "rgb(10, 8, 6)",
    "ONYX": "rgb(3, 1, 4)",
    "PITCH": "rgb(3, 0, 1)",
    "SOOT": "rgb(22, 13, 8)",
    "SABLE": "rgb(6, 6, 6)",
    "JET BLACK": "rgb(3, 3, 3)",
    "COAL": "rgb(12, 9, 8)",
    "METAL": "rgb(14, 12, 10)",
    "OBSIDIAN": "rgb(2, 4, 3)",
    "JADE": "rgb(0, 3, 2)",
    "SPIDER": "rgb(4, 2, 0)",
    "LEATHER": "rgb(11, 7, 5)",
    "ASPHALT": "rgb(12, 4, 4)",
    "LICORICE": "rgb(26, 17, 16)",
    "NIGHT": "rgb(12, 9, 10)",
    "Charleston green": "rgb(35, 43, 43)",
    "Dark jungle green": "rgb(26, 36, 33)",
    "Eerie black": "rgb(27, 27, 27)",
    "Raisin black": "rgb(36, 33, 36)",
    "Smoky black": "rgb(16, 12, 8)",
    "Black Rock": "rgb(1, 1, 39)",
    "Neutral Black": "rgb(11, 11, 11)",
    "Black Denim": "rgb(25, 28, 39)",
    "Vampire Black": "rgb(15, 4, 4)",
    "Cool Black": "rgb(21, 25, 34)",
    "Frost Black": "rgb(25, 28, 32)",
    "Power Black": "rgb(14, 12, 1)",
    "Premium Black": "rgb(16, 14, 9)",
    "Black Magic": "rgb(11, 5, 16)",
    "Alien Black": "rgb(26, 34, 40)",
    "Black Chocolate": "rgb(27, 24, 17)",
    "Gothic Grape": "rgb(18, 3, 33)",
    "Metropolis": "rgb(26, 26, 26)",
    "Night Shadow": "rgb(28, 28, 28)",
    "Dark Raisin": "rgb(26, 15, 15)",
    "Tea Bag": "rgb(22, 19, 17)",
    "Tech Black": "rgb(13, 14, 14)",
    "Dull Black": "rgb(22, 22, 22)",
    "Dark Black": "rgb(1, 2, 3)",
    "Natural Black": "rgb(7, 0, 11)",
    "Retro Black": "rgb(31, 32, 31)",
    "Deep Black": "rgb(5, 2, 3)",
    "GRAY": "rgb(128, 128, 128)",
    "SHADOW": "rgb(55, 55, 55)",
    "GRAPHITE": "rgb(89, 77, 91)",
    "IRON": "rgb(50, 45, 49)",
    "PEWTER": "rgb(105, 104, 128)",
    "CLOUD": "rgb(197, 198, 208)",
    "SILVER": "rgb(173, 173, 201)",
    "SMOKE": "rgb(89, 81, 94)",
    "DARK SLATE": "rgb(62, 61, 83)",
    "ANCHOR": "rgb(65, 66, 76)",
    "ASH": "rgb(86, 76, 77)",
    "PORPOISE": "rgb(77, 76, 92)",
    "DOVE": "rgb(124, 110, 127)",
    "FOG": "rgb(101, 89, 103)",
    "FLINT": "rgb(127, 125, 156)",
    "CHARCOAL GRAY": "rgb(35, 32, 35)",
    "PEBBLE": "rgb(51, 51, 51)",
    "LEAD": "rgb(63, 63, 78)",
    "COIN": "rgb(152, 151, 169)",
    "FOSSIL": "rgb(120, 114, 118)",
    "ARSENIC": "rgb(59, 68, 75)",
    "NEVADA": "rgb(102, 106, 109)",
    "SCORPION": "rgb(94, 94, 94)",
    "Battleship Gray": "rgb(132, 132, 130)",
    "Carbon Gray": "rgb(98, 93, 93)",
    "Davy’s Gray": "rgb(85, 85, 85)",
    "Dim Gray": "rgb(105, 105, 105)",
    "Gray Cloud": "rgb(182, 182, 180)",
    "Gray Dolphin": "rgb(92, 88, 88)",
    "Gray Wolf": "rgb(80, 74, 75)",
    "Gunmetal": "rgb(42, 52, 57)",
    "Marengo": "rgb(76, 88, 102)",
    "Medium Gray": "rgb(190, 190, 190)",
    "Nickel": "rgb(114, 116, 114)",
    "Stone Gray": "rgb(146, 142, 133)",
    "Outer Space": "rgb(65, 74, 76)",
    "Rocket Metallic": "rgb(138, 127, 141)",
    "Silver Chalice": "rgb(172, 172, 172)",
    "Smokey Gray": "rgb(114, 110, 109)",
    "Sonic Gray": "rgb(117, 117, 117)",
    "Spanish Gray": "rgb(152, 152, 152)",
    "Taupe Gray": "rgb(139, 133, 137)",
    "Vampire Gray": "rgb(86, 80, 81)",
    "X11 Gray": "rgb(187, 188, 182)",
    "Dark Silver": "rgb(116, 109, 105)",
    "Pastel Gray": "rgb(204, 205, 198)",
    "Misty Gray": "rgb(188, 194, 194)",
    "Vintage Gray": "rgb(152, 150, 146)",
    "Zombie Gray": "rgb(99, 100, 94)",
    "Perfect Gray": "rgb(161, 161, 161)",
    "Columbia" : "#6bbbec",
    "Electric" : "#009bce",
    "Flamingo" : "#ff006f",
    "Gold" : "#d4af37",
    "Graphite" : "#9f9f9f",
    "Grape" : "#603a7f",
    "Light Blue" : "#92b2d5" ,
    "Light Pink" : "#f8e0e7",
    "Lizard" : "#42d62c",
    "Neon Green" : "#42d62c",
    "Neon Pink" : "#fa008a",
    "Neon Yellow" : "#faec27",
    "Neon Orange" : "#fa914b",
    "Neon Blue" : "#00a4de",
    "Pearl" : "#ffffff",
    "Punch" : "#ef0ee4",
    "Pink" : "#d3468f",
    "Solar" : "#f5f529",
    "Surgeon Green" : "#5dbaa9",
    "Hopkins" : "#002e72",
    "Syracuse" : "#d44700" ,
    "Pacific" : "#6bbbec",
    "Clear" : "#d9ffff",
    "Blush" : "#ff15ec",
    "Blue Steel" : "#7b9095",
    "Ivory" : "#FFFFF0",
    "Camo" : " #78866B",
    "Galaxy" : "#2d2926",
    "Taxi" : "#EED202",
    "Capri" : "#00d5ff",
    "Ice Blue" : "#739BD0",
    "Platinum" : "#b5b3b6",
    "Dragonfruit" : "#f0025a",
    "Cool Mint" : "#02ad9d",
    "Deep Sea" : "#006479",
    "South Beach Silver" : "#d4d2d3",
    "USA" : "#3171c6",
    "Glacier" : "#83e7e7",
    "Cotton Candy" : "#fb7bb3",
    "Pastel Blue" : "#b5c5e0",
    "Pastel Pink" : "#ebbdbe",
    "Pastel Purple" : "#c6acd2",
    "Pastel Green" : "#c1d1c5"
};
  
// Fuction to apply bg color to the color labels in the card product
// We Create a new object of colors and tranform them in lowercase regardless the case.
const lowerCaseColorMap = Object.keys(colorMap).reduce((acc, key) => {
  acc[key.toLowerCase()] = colorMap[key]; 
  return acc;
}, {});

function applyMultiColorSwatch() {
  const swatchElements = document.querySelectorAll('.color-swatch-radio');

  swatchElements.forEach(function (swatchElement) {
    let backgroundStyle;
    const swatchValue = swatchElement.value.toLowerCase(); // Ensure the swatch value is lowercase

    if (swatchValue.includes('/')) {
      const colors = swatchValue.split('/');
      const gradientColors = colors.map((color, index) => {
        const lowerColor = color.toLowerCase(); // Convert each color to lowercase
        const hexColor = lowerCaseColorMap[lowerColor] ? lowerCaseColorMap[lowerColor] : lowerColor; 
        const percentage = 100 / colors.length; 
        return `${hexColor} ${percentage * index}%, ${hexColor} ${percentage * (index + 1)}%`; 
      });
      backgroundStyle = `linear-gradient(90deg, ${gradientColors.join(', ')})`; 
    } else {
      backgroundStyle = lowerCaseColorMap[swatchValue] ? lowerCaseColorMap[swatchValue] : swatchValue;
    }

    swatchElement.style.background = backgroundStyle;
  });
}

function initializeObserver() {
  const productGridContainer = document.querySelector('.product-grid-container');
  if (productGridContainer) {
    const observer = new MutationObserver(function(mutationsList, observer) {
      applyMultiColorSwatch();
      observer.disconnect();
      initializeObserver(); 
    });

    observer.observe(productGridContainer, { childList: true, subtree: true });
  }
}

document.addEventListener("DOMContentLoaded", function() {
  applyMultiColorSwatch();
  initializeObserver();
});
  

      // Function to change the image according to the swatch selected
      let selectedVariantName = null;

      function updateProductImage(newImageUrl, productId, variantId, counterVariantColor, variantName, productUrl) {
        if (counterVariantColor > 1) {
          let carouselContainer = document.getElementById('carousel-container-' + productId);
          let productMediaGallery = document.getElementById('product-media-gallery-' + productId);

          carouselContainer.classList.add('swatch-image');

          let variantImage = document.createElement('img');
          variantImage.src = newImageUrl;
          variantImage.srcset = `
            ${newImageUrl}?width=165 165w,
            ${newImageUrl}?width=360 360w,
            ${newImageUrl}?width=533 533w,
            ${newImageUrl}?width=720 720w,
            ${newImageUrl}?width=940 940w,
            ${newImageUrl}?width=1066 1066w
          `;
          
          variantImage.style.display = 'none';
          variantImage.style.cursor = 'pointer';
          
          // Add click handler to navigate to product page
          variantImage.addEventListener('click', () => {
            window.location.href = `${productUrl}?variant=${variantId}`;
          });

          if (productMediaGallery) {
            productMediaGallery.innerHTML = '';
            productMediaGallery.appendChild(variantImage);
          }

          variantImage.style.display = 'block';

          selectedVariantName = variantName;
          selectedVarianId = variantId;
        }
      }

      document.querySelectorAll('.color-swatch-radio').forEach((swatch) => {
        swatch.addEventListener('click', (event) => {
          const newImageUrl = swatch.getAttribute('data-image-url');
          const productId = swatch.getAttribute('data-product-id');
          const variantId = swatch.getAttribute('data-variant-id');
          const counterVariantColor = swatch.getAttribute('data-counter-variant-color');
          const variantName = swatch.getAttribute('data-variant-name');
          const productUrl = swatch.getAttribute('data-product-url');

          updateProductImage(newImageUrl, productId, variantId, counterVariantColor, variantName, productUrl);
        });
      });

                // Fuction to apply bg color to the color labels on the product page
                function applyLabelColorSwatch() {
                  const colorInputs = document.querySelectorAll('input.color-pdp-swatches');
                
                  colorInputs.forEach((input) => {
                    const label = document.querySelector(`label[for='${input.id}']`);
                    if (!label) return;
                
                    const swatchValue = input.value.toLowerCase();
                    let backgroundStyle;
                
                    if (swatchValue.includes('/')) {
                      const colors = swatchValue.split('/');
                      const gradientColors = colors.map((color, index) => {
                        const lowerColor = color.toLowerCase();
                        const hexColor = lowerCaseColorMap[lowerColor] || lowerColor;
                        const percentage = 100 / colors.length;
                        return `${hexColor} ${percentage * index}%, ${hexColor} ${percentage * (index + 1)}%`;
                      });
                      backgroundStyle = `linear-gradient(90deg, ${gradientColors.join(', ')})`;
                    } else {
                      backgroundStyle = lowerCaseColorMap[swatchValue] || swatchValue;
                    }
                
                    // Apply background style
                    label.style.background = backgroundStyle;
                    label.textContent = ''; 
                
                
                    // Add ARIA attributes for accessibility
                    const colorName = input.value.charAt(0).toUpperCase() + input.value.slice(1); // Capitalize color name
                    input.setAttribute("aria-label", colorName); // Associate name with input
                  });
                }
                
        
        function handleLabelClick(event) {
          if (event.target.tagName !== 'LABEL') return;
        
          const swatchContainer = event.currentTarget;
          const labels = swatchContainer.querySelectorAll('label');
        
          labels.forEach((label) => label.classList.remove('active'));
          event.target.classList.add('active');
        }
        
        function initializeSwatchObserver() {
          const swatchContainer = document.querySelector('.product-form__input.Color');
          if (swatchContainer) {
            const observer = new MutationObserver(() => {
              applyLabelColorSwatch();
              observer.disconnect(); 
              initializeSwatchObserver(); 
            });
        
            observer.observe(swatchContainer, { childList: true, attributes: true, subtree: true });
          }
        }
        
        document.addEventListener('DOMContentLoaded', () => {
          applyLabelColorSwatch();
          initializeSwatchObserver();
        });
        


        
// Function to apply background color to the SVGs in filters
function applyFilterSvgColorSwatch() {
  const colorInputs = document.querySelectorAll('.mobile-facets__item .mobile-facets__checkbox');

  colorInputs.forEach((input) => {
    // Use closest label and find the first SVG within it
    const svg = input.closest('label').querySelector('svg:first-of-type');
    if (!svg) return;

    const swatchValue = input.value.toLowerCase();
    let backgroundStyle;

    if (swatchValue.includes('/')) {
      const colors = swatchValue.split('/');
      const gradientColors = colors.map((color, index) => {
        const hexColor = lowerCaseColorMap[color.toLowerCase()] || color;
        const percentage = 100 / colors.length;
        return `${hexColor} ${percentage * index}%, ${hexColor} ${percentage * (index + 1)}%`;
      });
      backgroundStyle = `linear-gradient(90deg, ${gradientColors.join(', ')})`;
    } else {
      backgroundStyle = lowerCaseColorMap[swatchValue] || swatchValue;
    }

    svg.style.background = backgroundStyle;
  });
}

function initializeFilterSwatchObserver() {
  const swatchContainer = document.querySelector('.mobile-facets__details.js-filter.Color');
  if (swatchContainer) {
    const observer = new MutationObserver(() => {
      applyFilterSvgColorSwatch();
      observer.disconnect();
      initializeFilterSwatchObserver();
    });

    observer.observe(swatchContainer, { childList: true, attributes: true, subtree: true });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  applyFilterSvgColorSwatch();
  initializeFilterSwatchObserver();

  document.querySelectorAll('.mobile-facets__item .mobile-facets__checkbox').forEach((input) => {
    input.addEventListener('change', applyFilterSvgColorSwatch);
  });

  document.querySelectorAll('.mobile-facets__details').forEach((details) => {
    details.addEventListener('toggle', (event) => {
      if (event.target.open) {
        applyFilterSvgColorSwatch();
      }
    });
  });
});
        function handleMobileColorSwatches() {
          const swatchContainers = document.querySelectorAll('.color-swatches');

          swatchContainers.forEach(container => {
            const swatches = container.querySelectorAll('.color-swatch-radio');
            
            if (swatches.length > 5) {
              container.classList.add('four-plus-swatches');
              
              swatches.forEach(swatch => {
                swatch.classList.remove('show-on-mobile');
              });
              
              for (let i = 0; i < 5; i++) {
                swatches[i].classList.add('show-on-mobile');
              }

              const plusElement = document.createElement('div');
              plusElement.textContent = '+';
              plusElement.classList.add('show-more-swatches');
              container.appendChild(plusElement); // Add the plus icon after the last color swatch
            }
          });
        }

        document.addEventListener('DOMContentLoaded', () => {
          handleMobileColorSwatches();
        });
